/* @flow */

import * as React from 'react';

import styles from './NavigationButton.module.scss';

type TypeProps = {
  children: React.Node,
};

class NavigationButton extends React.Component<*> {
  render(): React.Node {
    const { children, ...otherProps }: TypeProps = this.props;

    return (
      <span className={styles['navigation-button']} {...otherProps}>
        {children}
      </span>
    );
  }
}

export default NavigationButton;
